import { render, staticRenderFns } from "./discounting.vue?vue&type=template&id=09fbbf87"
import script from "./discounting.vue?vue&type=script&lang=js"
export * from "./discounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports